import * as React from "react";
function SvgCheckmarkGreen(props: React.SVGProps<SVGSVGElement>) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={13} height={10} viewBox="0 0 13 10" {...props}><g id="Group_1483" transform="translate(-6049 3042)"><path id="checkmark-blue" d="M11.14,0,4.83,6.31l-3-3L0,5.19,4.83,10,13,1.86Z" transform="translate(6049 -3042)" fill="#00615c" /></g></svg>;
}
export default SvgCheckmarkGreen;